import { useRef, useState } from 'react';
import styled from 'styled-components';
import vector from '../../assets/vector.svg?url';
import { RawHtmlFromTrustedSource } from './RawHtmlFromTrustedSource';

type Props = {
  title: string;
  content: string;
};

function Accordion({ title, content }: Props) {
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState('0px');

  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = () => {
    setActive(!active);
    setHeight(active ? '0px' : `${contentRef.current?.scrollHeight}px`);
  };

  return (
    <div>
      <Button type="button" onClick={toggleAccordion}>
        <Title>{title}</Title>
        <Icon src={vector} $rotate={active} />
      </Button>
      <Content ref={contentRef} maxHeight={height}>
        <ContentText>
          {RawHtmlFromTrustedSource({
            html: content
          })}
        </ContentText>
      </Content>
    </div>
  );
}

const Button = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;

  display: flex;
  align-items: center;

  margin-top: 28px;
  border: none;
  outline: none;
  transition: background-color 0.6s ease;
`;

const Title = styled.p`
  font-size: 16px;
  color: #bf0900;
  font-weight: 600;
  font-family: 'Open Sans';
`;

interface AccordionIconProps {
  $rotate?: boolean;
}

const Icon = styled.img<AccordionIconProps>`
  margin-left: 8px;
  transition: transform 0.6s ease;
  transform: ${props => (props.$rotate ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

interface AccordionContentProps {
  maxHeight: string;
}

const Content = styled.div<AccordionContentProps>`
  background-color: transparent;
  overflow: hidden;
  transition: max-height 0.6s ease;
  max-height: ${props => props.maxHeight};
`;

const ContentText = styled.div`
  padding-top: 28px;
`;

export default Accordion;
